export const transformModalState: Record<string, unknown> = {}
